import { render, staticRenderFns } from "./CampaignPromotionQuery.vue?vue&type=template&id=277b7378&"
import script from "./CampaignPromotionQuery.vue?vue&type=script&lang=js&"
export * from "./CampaignPromotionQuery.vue?vue&type=script&lang=js&"
import style0 from "./CampaignPromotionQuery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CampaignPromotionQuery.vue"
export default component.exports